import React, { useEffect, useState } from 'react';
import AdminProductCard from './AdminVolunteeringCard';
import { db } from '../../firebase';
import { collection, getDocs, query } from 'firebase/firestore';
import "../../css/Admin-Volunteering/AllVolunteering.css";
import UploadVolunteering from './UploadVolunteering';

const AllVolunteering = () => {
    const [openUploadProject, setOpenUploadProject] = useState(false);
    const [allProjects, setAllProjects] = useState([]);

    async function fetchListings() {
        try {
            const projectRef = collection(db, 'volunteering');
            const q = query(projectRef);
            const querySnap = await getDocs(q);
            let projects = [];
            querySnap.forEach((doc) => {
                projects.push({
                    id: doc.id,
                    data: doc.data()
                });
            });
            setAllProjects(projects);
            //console.log(projects);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchListings();
    }, []);

    return (
        <div className="all-products-container">
            <div className="header-section">
                <h2 className="page-title">All Volunteering</h2>
                <button
                    className="upload-button"
                    onClick={() => setOpenUploadProject(true)}
                >
                    Upload Volunteering
                </button>
            </div>

            <div className="products-list">
                {allProjects.map((project) => (
                    <AdminProductCard
                        data={project.data}
                        projectKey={project.id}
                        fetchData={fetchListings}
                    />
                ))}
            </div>

            {/* upload product component */}
            {
                openUploadProject && (
                    <UploadVolunteering onClose={()=>setOpenUploadProject(false)} fetchData={fetchListings}/>
                )
            }
        </div>
    );
};

export default AllVolunteering;
